// extracted by mini-css-extract-plugin
module.exports = {"icon":"IconButton_icon__2YBpS","container":"IconButton_container__Ug9WW"};